"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_uid_1 = require("react-uid");
const material_1 = require("@mui/material");
const DeleteOutlineOutlined_1 = __importDefault(require("@mui/icons-material/DeleteOutlineOutlined"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const react_swipe_to_delete_ios_1 = __importDefault(require("react-swipe-to-delete-ios"));
const QuantityPicker_1 = __importDefault(require("./QuantityPicker"));
const OrderHeadline = styled_components_1.default.div `
  h3 {
    margin: 0;
  }
`;
const ItemName = styled_components_1.default.div `
  font-size: 1.2rem;
`;
const ItemComment = styled_components_1.default.div `
  color: rgba(0, 0, 0, 0.6);
`;
const ItemsWrapper = styled_components_1.default.div `
  background: #fafafa;
  border-radius: 5px;
  margin-top: 15px;
  #delete-container {
    border-bottom: 1px solid rgb(217, 217, 217);
  }

  .align-right {
    text-align: right;
  }
`;
const BasketItem = styled_components_1.default.div `
  float: none;
  &.marked-for-deletion {
    float: right;
  }
  display: flex;
  .MuiGrid-container {
    background: #fafafa;
    padding: 16px;
    width: 100vw;
  }
`;
const Anchor = styled_components_1.default.div `
  height: auto;
  background: transparent;
  width: 0;
  &.marked-for-deletion {
    width: 75px;
  }
  transition: width 0.2s ease-out;
`;
const ServiceFees = styled_components_1.default.div `
  background: #fafafa;
  color: rgba(0, 0, 0, 0.6);
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  > div {
    flex-basis: 50%;
  }
`;
const BasketItemsWrapper = styled_components_1.default.div `
  button {
    text-transform: initial;
  }
`;
const BasketTotal = styled_components_1.default.div `
  font-size: 1.2rem;
  width: 100%;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  > div {
    flex-basis: 50%;
  }
  padding: 16px;
`;
const FieldValidationError = styled_components_1.default.div `
  color: red;
  font-style: italic;
  div::first-letter {
    text-transform: uppercase;
  }
`;
const BasketItems = (props) => {
    const { showMenu, orderData, deleteItemFromBasket, reviewOrder, shoppingCartField, } = props;
    const [markedForDeletion, setMarkedForDeletion] = (0, react_1.useState)(new Set());
    const handleClickOutside = (event) => {
        if (!event.target.closest(".marked-for-deletion")) {
            setMarkedForDeletion(new Set());
        }
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, []);
    const openMenu = (e) => {
        e.preventDefault();
        showMenu();
        setMarkedForDeletion(new Set());
    };
    const handleQuantityChange = (item, quantity, itemIndex) => {
        if (orderData) {
            if (quantity > 0) {
                const updatedBasket = orderData.order.lineItems.map((basketItem, index) => {
                    markedForDeletion.delete(index);
                    if (itemIndex === index) {
                        return Object.assign(item, { quantity });
                    }
                    return basketItem;
                });
                reviewOrder(updatedBasket, "update quantity");
            }
            else {
                setMarkedForDeletion(new Set([itemIndex]));
            }
        }
    };
    const onDelete = (index) => {
        deleteItemFromBasket(index);
        markedForDeletion.delete(index);
    };
    const renderBasketItems = () => {
        if (!orderData) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        const serviceFee = orderData.order.lineItems.find((lineItem) => Object.prototype.hasOwnProperty.call(lineItem, "serviceFeeId"));
        return (react_1.default.createElement(react_1.default.Fragment, null,
            orderData.order.lineItems.map((item, index) => (react_1.default.createElement(react_1.default.Fragment, { key: (0, react_uid_1.uid)(item) }, item.productId ? (react_1.default.createElement(react_swipe_to_delete_ios_1.default, { key: (0, react_uid_1.uid)(item), height: 100, onDelete: () => onDelete(index), deleteComponent: react_1.default.createElement(DeleteOutlineOutlined_1.default, null) },
                react_1.default.createElement(BasketItem, { className: markedForDeletion.has(index) ? "marked-for-deletion" : "" },
                    react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(ItemName, null, item.name)),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(QuantityPicker_1.default, { item: item, itemIndex: index, onChange: handleQuantityChange })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 }, item.comment && (react_1.default.createElement(ItemComment, null, item.comment))),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 }, item.total)),
                    react_1.default.createElement(Anchor, { onClick: () => onDelete(index), className: markedForDeletion.has(index) ? "marked-for-deletion" : "" })))) : (react_1.default.createElement(react_1.default.Fragment, null))))),
            serviceFee && (react_1.default.createElement(ServiceFees, null,
                orderData.order.subTotal && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", null, i18n_js_1.default.t("subtotal")),
                    react_1.default.createElement("div", { className: "align-right" }, orderData.order.subTotal))),
                react_1.default.createElement("div", null, serviceFee.name),
                react_1.default.createElement("div", { className: "align-right" }, serviceFee.total))),
            react_1.default.createElement(BasketTotal, null,
                react_1.default.createElement("div", null, i18n_js_1.default.t("total")),
                react_1.default.createElement("div", { className: "align-right" }, orderData.order.total))));
    };
    (0, react_1.useEffect)(() => {
        // the swipe to delete button doesn't have a type set so it's triggering the form submit when we delete an item from the basket
        // see if we can improve this
        const deleteButtons = document.querySelectorAll("#delete-button");
        if (deleteButtons) {
            deleteButtons.forEach((deleteButton) => {
                deleteButton.setAttribute("type", "button");
            });
        }
    });
    return (react_1.default.createElement(BasketItemsWrapper, null,
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 2, sx: { alignItems: "center" } },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                react_1.default.createElement(OrderHeadline, null, shoppingCartField && react_1.default.createElement("h3", null, shoppingCartField.label))),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                react_1.default.createElement(material_1.Button, { startIcon: react_1.default.createElement(Add_1.default, null), onClick: (e) => openMenu(e), color: "mainAppColor", variant: "outlined" },
                    " ",
                    i18n_js_1.default.t("add_more_items")))),
        orderData && orderData.order.lineItems.length > 0 && (react_1.default.createElement(ItemsWrapper, null, renderBasketItems())),
        react_1.default.createElement(FieldValidationError, null, shoppingCartField && shoppingCartField.errors ? (shoppingCartField.errors.map((error) => (react_1.default.createElement("em", { key: (0, react_uid_1.uid)(error) }, error)))) : (react_1.default.createElement(react_1.default.Fragment, null)))));
};
exports.default = BasketItems;
